import { EMPLOYMENT_VALUES as EMPLOYMENT_TYPE_VALUES } from '@sravni/creditselection-customer-utils/lib/utils/customers';

import type { TWorkplaceFormFields } from 'entities/creditForm';

const EmploymentTypeCommonWorkFields: Array<Partial<keyof TWorkplaceFormFields>> = [
  'workOrganizationName',
  'employerInn',
  'employerType',
  'lastWorkExperienceStartMonth',
  'areaOfEmployment',
  'workPhone',
  'workAddress',
  'jobTitle',
  'monthlySalary',
];

/** Поля, зависящие от значения поля employmentType */
export const EmploymentTypeDependencies: Record<
  ValuesOf<typeof EMPLOYMENT_TYPE_VALUES>,
  Array<Partial<keyof TWorkplaceFormFields>>
> = {
  [EMPLOYMENT_TYPE_VALUES.BUSINESS_OWNER]: EmploymentTypeCommonWorkFields.filter(
    (field) => !['jobTitle', 'jobType'].includes(field),
  ),
  [EMPLOYMENT_TYPE_VALUES.JUDGE]: EmploymentTypeCommonWorkFields,
  [EMPLOYMENT_TYPE_VALUES.SERVICEMAN]: EmploymentTypeCommonWorkFields,
  [EMPLOYMENT_TYPE_VALUES.STATE_EMPLOYEE]: EmploymentTypeCommonWorkFields,
  [EMPLOYMENT_TYPE_VALUES.RETIRED]: ['monthlySalary'],
  [EMPLOYMENT_TYPE_VALUES.NOT_WORKING_VALUE]: ['unemploymentReason', 'anotherUnemploymentReason'],
  [EMPLOYMENT_TYPE_VALUES.EMPLOYMENT]: EmploymentTypeCommonWorkFields,
};
